import {
  isNavigationFailure,
  NavigationFailureType,
} from "vue-router";

const WRAPPED_MARKER = "__livenessNavigationFailureHandled";

export function isExpectedNavigationFailure(error) {
  return (
    isNavigationFailure(error, NavigationFailureType.redirected) ||
    isNavigationFailure(error, NavigationFailureType.duplicated)
  );
}

function wrapNavigationMethod(Router, methodName) {
  const original = Router && Router.prototype && Router.prototype[methodName];
  if (typeof original !== "function" || original[WRAPPED_MARKER]) return;

  function navigationWithExpectedFailureHandling(
    location,
    onComplete,
    onAbort
  ) {
    const result = original.call(this, location, onComplete, onAbort);
    if (
      onComplete ||
      onAbort ||
      !result ||
      typeof result.catch !== "function"
    ) {
      return result;
    }

    return result.catch(error => {
      if (isExpectedNavigationFailure(error)) return error;
      throw error;
    });
  }

  Object.defineProperty(navigationWithExpectedFailureHandling, WRAPPED_MARKER, {
    value: true,
  });
  Router.prototype[methodName] = navigationWithExpectedFailureHandling;
}

export function installExpectedNavigationFailureHandling(Router) {
  wrapNavigationMethod(Router, "push");
  wrapNavigationMethod(Router, "replace");
}
